import type { PageProps } from 'gatsby';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import MainTitle from '@components/MainTitle';

import AppLayout from '@layouts/AppLayout';
import { MainContainer } from '@layouts/DrilldownStyle';

import EMRConnections from '@views/EMRConnections/Main';

const messages = defineMessages({
  emrConnections: {
    id: 'connectionsMain.emrConnections',
    defaultMessage: 'Hospitals and Clinics (EMRs)',
  },
});

export default function EMRConnectionsPage({ params }: PageProps) {
  const { formatMessage } = useIntl();
  return (
    <AppLayout showHeader>
      <MainContainer>
        <MainTitle title={formatMessage(messages.emrConnections)} />
        <EMRConnections {...params} />
      </MainContainer>
    </AppLayout>
  );
}
